export default __webpack_public_path__ + "static/media/CNo.88-6.067aa9a9.jpg";